var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "snap-card" }, [
    _c("div", {
      staticClass: "pic cvr",
      style: { backgroundImage: "url(" + _vm.posterSrc + ")" },
    }),
    _vm._v(" "),
    _c("span", { staticClass: "cap-title ft-xbld" }, [
      _vm._v(_vm._s(_vm.title)),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "hvr" }, [
      _c("span", { staticClass: "ico" }, [
        _c(
          "svg",
          {
            attrs: {
              width: "26",
              height: "26",
              viewBox: "0 0 26 26",
              fill: "none",
            },
          },
          [
            _c("path", {
              attrs: {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM11.5 11.5V6.5H14.5V11.5H19.5V14.5H14.5V19.5H11.5V14.5H6.5V11.5H11.5Z",
                fill: "#FFBB36",
              },
            }),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }